import {VirtualTrayActionTypes} from 'constants/actionType';

export const setFocusedDeckNumber = (deckNumber) => ({
  type: VirtualTrayActionTypes.SET_FOCUSED_DECK_NUMBER,
  deckNumber,
});

export const setDeckLabwareRefs = (deckLabwareRefs) => ({
  type: VirtualTrayActionTypes.SET_DECK_LABWARE_REFS,
  deckLabwareRefs,
});

export const setAspirateDispenseVolumeModal = (volumeModalData) => ({
  type: VirtualTrayActionTypes.SET_ASP_DISP_VOLUME_MODAL,
  volumeModalData,
});

export const setVirtualTrayShownModal = (shownModal) => ({
  type: VirtualTrayActionTypes.SET_SHOWN_MODAL,
  shownModal,
});

export const resetVirtualTrayShownModal = () => ({
  type: VirtualTrayActionTypes.SET_SHOWN_MODAL,
  shownModal: '',
});

export const hideAspirateDispenseVolumeModal = () => ({
  type: VirtualTrayActionTypes.RESET_ASP_DISP_VOLUME_MODAL,
});

export const restoreVirtualTrayState = (state) => ({
  type: VirtualTrayActionTypes.RESTORE_VIRTUAL_TRAY_STATE,
  state,
});

export const resetVirtualTrayState = () => ({
  type: VirtualTrayActionTypes.RESET_VIRTUAL_TRAY_STATE,
});
